import Axios from 'axios'

export default {
    name: 'satuan',
    state: {
        satuanList: []
    },
    getters: {
        getSatuan: state => {
            return state.satuanList
        }
    },
    mutations: {
        SATUAN: (state, payload) => {
            state.satuanList = payload
        }
    },
    actions: {
        Fetch_Satuan(store) {
            return Axios({
                method: "get",
                url: "./json/satuan.json",
                auth: {
                    username: store.rootState.user.auth.username,
                    password: store.rootState.user.auth.password
                },
                headers: {
                    'X-API-KEY': store.rootState.user.auth.apikey
                }
            }).then(response => {
                store.commit('SATUAN', response.data);
            }).catch(err => {
                return err
            });
        },
    }
}